<main class="admin-shell">
  <section class="admin-container">
    <header class="admin-header">
      <div>
        <p class="eyebrow">{{ 'common.ssoBrand' | translate }}</p>
        <h1>{{ 'adminPolicy.title' | translate }}</h1>
        <p class="subtitle">{{ 'adminPolicy.subtitle' | translate }}</p>
      </div>
      <a nz-button routerLink="/main">{{ 'common.backToModules' | translate }}</a>
    </header>

    @if (errorMessage) {
      <nz-alert nzType="error" [nzMessage]="errorMessage" nzShowIcon></nz-alert>
    }

    <nz-spin [nzSpinning]="isLoading">
      <form [formGroup]="form" (submit)="$event.preventDefault(); save()">
        <div class="policy-grid">
          <nz-card [nzTitle]="'adminPolicy.complexity' | translate">
            <label class="policy-row">
              <span>{{ 'adminPolicy.minLength' | translate }}</span>
              <nz-input-number formControlName="minLength" [nzMin]="6" [nzMax]="128" [nzStep]="1"></nz-input-number>
            </label>

            <label class="policy-row">
              <span>{{ 'adminPolicy.requireDigit' | translate }}</span>
              <nz-switch formControlName="requireDigit"></nz-switch>
            </label>

            <label class="policy-row">
              <span>{{ 'adminPolicy.requireLower' | translate }}</span>
              <nz-switch formControlName="requireLowercase"></nz-switch>
            </label>

            <label class="policy-row">
              <span>{{ 'adminPolicy.requireUpper' | translate }}</span>
              <nz-switch formControlName="requireUppercase"></nz-switch>
            </label>

            <label class="policy-row">
              <span>{{ 'adminPolicy.requireSymbol' | translate }}</span>
              <nz-switch formControlName="requireNonAlphanumeric"></nz-switch>
            </label>

            <label class="policy-row">
              <span>{{ 'adminPolicy.uniqueChars' | translate }}</span>
              <nz-input-number formControlName="requiredUniqueChars" [nzMin]="0" [nzMax]="16" [nzStep]="1"></nz-input-number>
            </label>
          </nz-card>

          <nz-card [nzTitle]="'adminPolicy.expiry' | translate">
            <label class="policy-row">
              <span>{{ 'adminPolicy.historyDepth' | translate }}</span>
              <nz-input-number formControlName="historyDepth" [nzMin]="0" [nzMax]="24" [nzStep]="1"></nz-input-number>
            </label>

            <label class="policy-row">
              <span>{{ 'adminPolicy.minAgeHours' | translate }}</span>
              <nz-input-number formControlName="minAgeHours" [nzMin]="0" [nzMax]="720" [nzStep]="1"></nz-input-number>
            </label>

            <label class="policy-row">
              <span>{{ 'adminPolicy.maxAgeDays' | translate }}</span>
              <nz-input-number formControlName="maxAgeDays" [nzMin]="0" [nzMax]="3650" [nzStep]="1"></nz-input-number>
            </label>

            <p class="policy-hint">{{ 'adminPolicy.expiryHint' | translate }}</p>
          </nz-card>

          <nz-card [nzTitle]="'adminPolicy.lockout' | translate">
            <label class="policy-row">
              <span>{{ 'adminPolicy.attempts' | translate }}</span>
              <nz-input-number formControlName="lockoutMaxFailedAttempts" [nzMin]="1" [nzMax]="50" [nzStep]="1"></nz-input-number>
            </label>

            <label class="policy-row">
              <span>{{ 'adminPolicy.duration' | translate }}</span>
              <nz-input-number formControlName="lockoutDurationMinutes" [nzMin]="1" [nzMax]="10080" [nzStep]="1"></nz-input-number>
            </label>

            <label class="policy-row">
              <span>{{ 'adminPolicy.inactivityDays' | translate }}</span>
              <nz-input-number formControlName="inactivityLockDays" [nzMin]="0" [nzMax]="3650" [nzStep]="1"></nz-input-number>
            </label>

            <p class="policy-hint">{{ 'adminPolicy.inactivityHint' | translate }}</p>
          </nz-card>
        </div>

        <div class="policy-actions">
          @if (updatedAt) {
            <span class="policy-updated">{{ 'adminPolicy.updated' | translate }} {{ updatedAt }}</span>
          }
          <button nz-button type="button" (click)="reset()" [disabled]="isSaving">{{ 'adminPolicy.reset' | translate }}</button>
          <button nz-button nzType="primary" type="submit" [nzLoading]="isSaving">{{ 'common.save' | translate }}</button>
        </div>
      </form>
    </nz-spin>
  </section>
</main>
